const common = {
  // Navigation
  "nav.categories": "Categories",
  "nav.guides": "Guides",
  "nav.about": "About",
  "nav.faq": "FAQ",
  "nav.cta": "Buy It Now",
  "nav.home": "Home",
  "nav.shoppingGuide": "Shopping Guide",

  // Language names
  "lang.en": "English",
  "lang.fr": "Français",
  "lang.de": "Deutsch",
  "lang.es": "Español",
  "lang.pt": "Português",

  // Hero
  "hero.badge": "Basetao Spreadsheet Resource Hub",
  "hero.title": "Basetao Spreadsheet: Find Products, Sellers & Buying Guides",
  "hero.subtitle":
    "A clean, independent resource hub that helps you explore Basetao product categories, curated links and practical buying guidance — all in one place.",
  "hero.cta1": "Basetao Spreadsheet",
  "hero.cta2": "Buy It Now",
  "hero.dropdownLabel": "Jump to a category",

  // Category dropdown
  "cat.dropdownPlaceholder": "Choose a category…",

  // Category section
  "catSection.eyebrow": "Shop the Spreadsheet",
  "catSection.title": "Explore Categories",
  "catSection.subtitle":
    "Browse the most popular product categories in the Basetao Spreadsheet and jump straight to the items you are looking for.",
  "catSection.shopNow": "Shop now",

  // Category names
  "cat.shoes": "Shoes",
  "cat.hoodies": "Hoodies / Sweaters",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Jackets",
  "cat.pants": "Pants / Shorts",
  "cat.headwear": "Headwear",
  "cat.sets": "Sets",
  "cat.underwear": "Underwear",
  "cat.jersey": "Jersey",
  "cat.accessories": "Accessories",
  "cat.bags": "Bags",
  "cat.belts": "Belts",
  "cat.perfumes": "Perfumes",
  "cat.other": "Other Stuff",

  // Guides section
  "guides.eyebrow": "Guides & Resources",
  "guides.title": "Popular Guides",
  "guides.subtitle":
    "Original, practical articles that explain how to use the Basetao Spreadsheet and shop with confidence.",
  "guides.readMore": "Read the guide",
  "guides.card.badge": "Beginner Guide",
  "guides.card.title": "Basetao Spreadsheet Guide: What It Is & How to Use It",
  "guides.card.excerpt":
    "A clear, beginner-friendly walkthrough of what a Basetao Spreadsheet is, how to read it and how to use it to find products, sellers and better prices.",

  // About section
  "about.eyebrow": "What is it?",
  "about.title": "What Is a Basetao Spreadsheet?",
  "about.p1":
    "A Basetao Spreadsheet is a shared, organized list of products, links, sellers and notes collected by shoppers who use Basetao to order from Chinese marketplaces and ship internationally. Instead of searching from scratch, you start from a curated set of items that other buyers have already found and checked.",
  "about.p2":
    "Because a spreadsheet is easy to filter, sort and share, it is a practical way to compare products across categories such as shoes, hoodies, t-shirts, jackets, bags and accessories, and to keep track of the sellers and quality-check notes that matter when you order.",
  "about.point1.title": "Curated products",
  "about.point1.text":
    "Links to specific items are organized by category, so you spend less time searching and more time comparing.",
  "about.point2.title": "Seller & QC notes",
  "about.point2.text":
    "Useful notes about sellers and quality-check observations help you spot reliable options before you order.",
  "about.point3.title": "Shareable & updatable",
  "about.point3.text":
    "Spreadsheets are easy to share and update, so the list stays fresh as new products and notes are added.",

  // Features section
  "features.eyebrow": "Why use it",
  "features.title": "Why Use a Basetao Spreadsheet?",
  "features.subtitle":
    "A few reasons shoppers rely on an organized spreadsheet when ordering through Basetao.",
  "features.f1.title": "Save time",
  "features.f1.text": "Start from a ready list instead of browsing dozens of pages one by one.",
  "features.f2.title": "Compare easily",
  "features.f2.text": "See products side by side across categories, sellers and prices.",
  "features.f3.title": "Stay organized",
  "features.f3.text": "Keep your picks, notes and quality-check details in one tidy place.",
  "features.f4.title": "Shop with context",
  "features.f4.text":
    "Combine product links with seller and QC notes to make more confident choices.",

  // FAQ section
  "faq.eyebrow": "FAQ",
  "faq.title": "Frequently Asked Questions",
  "faq.q1": "What is a Basetao Spreadsheet?",
  "faq.a1":
    "It is a shared, organized list of products, links, sellers and notes that shoppers use to find and compare items ordered through Basetao.",
  "faq.q2": "Is this website affiliated with Basetao?",
  "faq.a2":
    "No. BasetaoSheet.casa is an independent informational resource and is not necessarily affiliated with Basetao unless explicitly stated.",
  "faq.q3": "How do I use the categories on this page?",
  "faq.a3":
    "Pick a category from the dropdown or the grid and you will be taken to the matching product page on our main site, where you can browse the actual items.",
  "faq.q4": "Do I need an account to browse?",
  "faq.a4": "No, you can explore the categories and guides freely without signing up.",
  "faq.q5": "Are prices and sellers guaranteed?",
  "faq.a5":
    "Prices, availability and seller details can change. Always review the product page on the main site before placing an order.",

  // Final CTA
  "cta.title": "Ready to explore the full catalog?",
  "cta.subtitle": "Browse every category on the main site and find the items you have been looking for.",
  "cta.button": "Buy It Now",

  // Footer
  "footer.tagline":
    "Basetao Sheet is an independent resource hub for the Basetao Spreadsheet — helping shoppers explore products, categories and guides.",
  "footer.disclaimer": "Independent informational resource. Not necessarily affiliated with Basetao.",
  "footer.explore": "Explore",
  "footer.resources": "Resources",
  "footer.legal": "Legal",
  "footer.guide": "Spreadsheet Guide",
  "footer.home": "Home",
  "footer.categories": "Categories",
  "footer.about": "About",
  "footer.faq": "FAQ",
  "footer.rights": "All rights reserved.",

  // Breadcrumb / misc
  "home.breadcrumb": "Home",
  "article.notFound": "Article not found",
  "article.faqHeading": "Frequently Asked Questions",
  "article.conclusionHeading": "Final Thoughts",

  "notFound.title": "Page not found",
  "notFound.subtitle": "The page you are looking for does not exist or may have moved.",
};

export default common;